import JSZip from 'jszip';

let cachedLogoMap = null;

function decodeEmfToDataUrl(u8) {
  try {
    const view = new DataView(u8.buffer, u8.byteOffset, u8.byteLength);
    let offset = 0;
    while (offset < u8.byteLength - 8) {
      const iType = view.getUint32(offset, true);
      const nSize = view.getUint32(offset + 4, true);
      if (iType === 81) { // EMR_STRETCHDIBITS
        const offBmi = view.getUint32(offset + 48, true);
        const offBits = view.getUint32(offset + 56, true);
        
        const bmiOffset = offset + offBmi;
        const bitsOffset = offset + offBits;
        
        const biWidth = view.getInt32(bmiOffset + 4, true);
        const biHeight = view.getInt32(bmiOffset + 8, true);
        const biBitCount = view.getUint16(bmiOffset + 14, true);
        
        const width = Math.abs(biWidth);
        const height = Math.abs(biHeight);
        const isBottomUp = biHeight > 0;
        
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const imgData = ctx.createImageData(width, height);
        const data = imgData.data;
        
        if (biBitCount === 24) {
          const rowStride = Math.floor((width * 3 + 3) / 4) * 4;
          for (let y = 0; y < height; y++) {
            const srcY = isBottomUp ? (height - 1 - y) : y;
            const rowStart = bitsOffset + srcY * rowStride;
            for (let x = 0; x < width; x++) {
              const srcIdx = rowStart + x * 3;
              const b = u8[srcIdx];
              const g = u8[srcIdx + 1];
              const r = u8[srcIdx + 2];
              const dstIdx = (y * width + x) * 4;
              data[dstIdx] = r;
              data[dstIdx + 1] = g;
              data[dstIdx + 2] = b;
              data[dstIdx + 3] = 255;
            }
          }
        } else if (biBitCount === 32) {
          const rowStride = width * 4;
          for (let y = 0; y < height; y++) {
            const srcY = isBottomUp ? (height - 1 - y) : y;
            const rowStart = bitsOffset + srcY * rowStride;
            for (let x = 0; x < width; x++) {
              const srcIdx = rowStart + x * 4;
              const b = u8[srcIdx];
              const g = u8[srcIdx + 1];
              const r = u8[srcIdx + 2];
              const a = u8[srcIdx + 3] || 255;
              const dstIdx = (y * width + x) * 4;
              data[dstIdx] = r;
              data[dstIdx + 1] = g;
              data[dstIdx + 2] = b;
              data[dstIdx + 3] = a;
            }
          }
        }
        ctx.putImageData(imgData, 0, 0);
        return canvas.toDataURL('image/png');
      }
      if (nSize < 8) break;
      offset += nSize;
    }
  } catch (err) {
    console.error('Failed to decode EMF bitmap:', err);
  }
  return null;
}

export async function getExtractedSponsorLogos() {
  if (cachedLogoMap) {
    return cachedLogoMap;
  }

  try {
    const res = await fetch('/_assets/sponsor.docx');
    if (!res.ok) throw new Error('Could not load sponsor.docx');
    const blob = await res.blob();
    const zip = await JSZip.loadAsync(blob);
    
    const map = {};

    // 1. Process PNGs
    const pngFiles = Object.keys(zip.files).filter(f => f.startsWith('word/media/') && f.endsWith('.png'));
    for (const file of pngFiles) {
      const b64 = await zip.file(file).async('base64');
      const key = file.replace(/^word\//, ''); // e.g. "media/image11.png"
      map[key] = `data:image/png;base64,${b64}`;
    }

    // 2. Process EMFs
    const emfFiles = Object.keys(zip.files).filter(f => f.startsWith('word/media/') && f.endsWith('.emf'));
    for (const file of emfFiles) {
      const u8 = await zip.file(file).async('uint8array');
      const dataUrl = decodeEmfToDataUrl(u8);
      if (dataUrl) {
        const key = file.replace(/^word\//, ''); // e.g. "media/image1.emf"
        map[key] = dataUrl;
      }
    }

    cachedLogoMap = map;
    return map;
  } catch (err) {
    console.error('Failed to extract sponsor logos:', err);
    return {};
  }
}
